import request from '@/utils/request'

// 获取动态路由
export function getRouters(data) {
  return request({
    url: '/admin/setting/webMenu/list',
    method: 'post',
    data
  })
}

// 添加路由
export function addMenu(data) {
  return request({
    url: '/admin/setting/webMenu/add',
    method: 'post',
    data
  })
}

// 更新路由
export function updateMenu(data) {
  return request({
    url: '/admin/setting/webMenu/edit',
    method: 'post',
    data
  })
}

// 获取路由设置角色权限
export function getRoleRouter(data) {
  return request({
    url: '/admin/setting/webMenu/treeList',
    method: 'post',
    data
  })
}
